module.exports = __webpack_public_path__ + "public/base/error/theme/default/images/error-404.png";


//////////////////
// WEBPACK FOOTER
// ./public/base/error/theme/default/images/error-404.png
// module id = 308
// module chunks = 0